export function pente(positions) {
  // distance correspond à la distance calculé entre 2 coordonnées géographiques (grâce à la fonction distanceInKmBetweenEarthCoordinates())
  const listepente = [];
  const listedistance = [];

  const distanceTotal = Math.floor(distance(positions.at(0), positions.at(positions.length - 1)));

  const a = -0.05;
  const b = positions.at(positions.length - 1).altitude;

  for (let i = 0; i < positions.length; i += 1) {
    listedistance.push(distance(positions.at(0), positions.at(i)) - distanceTotal);
    listepente.push(a * Math.floor(distance(positions.at(0), positions.at(i)) - distanceTotal) + b);
  }

  // On reverse la liste pour obtenir une pente décroissante
  return listepente;
}

export const distance = (firstPosition, secondPosition) =>
  Math.acos(
    Math.sin((firstPosition.latitude * Math.PI) / 180) *
      Math.sin((secondPosition.latitude * Math.PI) / 180) +
      Math.cos((firstPosition.latitude * Math.PI) / 180) *
        Math.cos((secondPosition.latitude * Math.PI) / 180) *
        Math.cos(((firstPosition.longitude - secondPosition.longitude) * Math.PI) / 180)
  ) *
  6371 *
  1000;
